import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { executePayement } from '../../../features/payement/payementSlice';
import FormBtnLarge from '../../components/button/FormBtnLarge';
import AuthTexfield from '../../components/textfield/AuthTexfield';
import Layout from '../../layout/Layout';

const PaiementPage = () => {
    const {state} = useLocation()
    const [otp, setOtp] = useState("");
    const [telephone, setTelephone] = useState("");
    const [btnm, setBtnm] = useState('Effectuer le paiement');
    const [disable, setDisable] = useState(false);
    const [errors, setErrors] = useState("");
    const montant = 20000;
    const dispatch = useDispatch()
    
    const { payement, isSuccess } = useSelector(
        (state) => state.payement
    )
    const handleSubmit = (e) => {
        e.preventDefault()
        if(otp && telephone){
            setDisable(true)
            setBtnm('Traitement en cours...')
            const data = {
                code_otp: parseInt(otp),
                numero_de_paiement: telephone,
                montant: parseInt(20000),
                devise: "XOF",
                client: parseInt(4),
                moyen_de_paiement: parseInt(state.moyen),
                service: parseInt(15),
            }
            dispatch(executePayement(data))
        }else{
            setErrors("Veuillez remplir tous les champs")
        }
    }

    return (
        <Layout>
            <div className='ipay-ui-page__title'>
                <h1>Payement via IventPay</h1>
                <span>Votre montant a payé est de: {montant} XOF</span> <br />
                <span>Veuillez exécuter *144*4*6*{montant}# sur votre téléphone afin de géenérer le code OTP</span>
            </div>
            <div className='ipay-ui-page__container'>
                <form className='ipay-ui-page__form' onSubmit={handleSubmit}>
                    <div className='ipay-ui-page__form-group'>
                        <div>
                            <AuthTexfield label={'Code OTP'} name={'otop'} type={'text'} fnc={setOtp}>
                                {'Veuillez entrer le code otp généré'}
                            </AuthTexfield> 
                        </div>
                        <div>
                            <AuthTexfield label={'Téléphone'} name={'telephone'} type={'text'} fnc={setTelephone}>
                                {'Veuillez entrer votre numéro de télephone'}
                            </AuthTexfield> 
                        </div>
                    </div>

                    <div className='ipay-ui-otherlayout-form__action'>
                        <FormBtnLarge type={'submit'} mStyle={'is--primary'} disable={disable}>
                            {btnm}
                        </FormBtnLarge>
                    </div>
                </form>
            </div>
        </Layout>
    );
};

export default PaiementPage;